import { theme } from "@tm/utility/global";
import styled, { css, keyframes } from "styled-components";

const pulse = keyframes`
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
`;

const slideIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const ExcelUploadWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

export const UploadRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const HiddenInput = styled.input`
  display: none;
`;

export const UploadButton = styled.button<{
  disabled?: boolean;
  isLoading?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 200px;
  padding: 9px;
  border-radius: 8px;
  border: none;
  background: ${({ disabled }) =>
    disabled ? theme.lightGreyText : theme.blueText};
  color: ${theme.whiteText};
  font-size: 14px;
  font-weight: 600;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  transition: all 0.2s ease;
  height: 32px;

  &:hover:not(:disabled) {
    background: #0070cc;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 140, 255, 0.25);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  ${({ isLoading }) =>
    isLoading &&
    css`
      animation: ${pulse} 1.5s ease-in-out infinite;
      pointer-events: none;
    `}
`;

export const FileInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
  height: 32px;
  background: #f3f4f6;
  border-radius: 6px;
  animation: ${slideIn} 0.3s ease;
  max-width: 300px;
`;

export const FileDetails = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const FileIcon = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 4px;
  background: ${theme.greenText};
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    color: ${theme.whiteText};
    width: 12px;
    height: 12px;
  }
`;

export const FileName = styled.p`
  font-size: 12px;
  font-weight: 600;
  color: ${theme.blackText};
  margin: 0;
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const FileSize = styled.span`
  font-size: 11px;
  color: ${theme.greyText};
`;

export const RemoveButton = styled.button`
  padding: 4px;
  border: none;
  background: transparent;
  cursor: pointer;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${theme.greyText};
  transition: all 0.2s ease;

  svg {
    width: 14px;
    height: 14px;
  }

  &:hover {
    background: ${theme.darkGreyBg};
    color: ${theme.redText};
  }
`;

export const ErrorMessage = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;

  svg {
    flex-shrink: 0;
  }

  span {
    font-size: 12px;
    color: ${theme.redText};
  }
`;

export const LoadingSpinner = styled.div`
  width: 16px;
  height: 16px;
  border: 2px solid ${theme.whiteText};
  border-top-color: transparent;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;
